const getTargetElement = ($element) => {
  let target  = $element.data('target');

  return $(target);
};

module.exports = getTargetElement;
